import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ListIcon from "@mui/icons-material/List";
import CookieIcon from "@mui/icons-material/Cookie";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";
import PhishingIcon from "@mui/icons-material/Warning";
import DomainIcon from "@mui/icons-material/Domain";
import AppsIcon from "@mui/icons-material/Apps";
import Accordion from "components/Аccordion";

function OtherCredentials({ client }) {
  const { t } = useTranslation();

  const renderCreditCards = () => {
    if (!client.creditcards || client.creditcards.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_credit_cards_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">{t("user.credit_cards")}</div>
        <div className="accordion-grid-item-content">
          {client.creditcards.map((cc, index) => (
            <div key={`credit-card-${index}`} className="accordion-list-item">
              <CreditCardIcon
                style={{ fontSize: 16, marginRight: 8, color: "var(--blue-color)" }}
              />
              {cc}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderCombolists = () => {
    if (!client.combolists || client.combolists.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_combolists_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">{t("user.combolists")}</div>
        <div className="accordion-grid-item-content">
          {client.combolists.map((combo, index) => (
            <div key={`combolist-${index}`} className="accordion-list-item">
              <ListIcon style={{ fontSize: 16, marginRight: 8, color: "var(--blue-color)" }} />
              {combo}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderCookies = () => {
    if (!client.cookies || client.cookies.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_cookies_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">{t("user.cookies")}</div>
        <div className="accordion-grid-item-content">
          {client.cookies.map((cookie, index) => (
            <div key={`cookie-${index}`} className="accordion-list-item">
              <CookieIcon style={{ fontSize: 16, marginRight: 8, color: "var(--blue-color)" }} />
              <div>
                <div>
                  <strong>URL:</strong> {cookie.url || "N/A"}
                </div>
                <div>
                  <strong>Name:</strong> {cookie.name || "N/A"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderCookiesClient = () => {
    if (!client.cookiesClient || client.cookiesClient.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_cookies_client_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">{t("user.cookies_client")}</div>
        <div className="accordion-grid-item-content">
          {client.cookiesClient.map((cookie, index) => (
            <div key={`cookie-client-${index}`} className="accordion-list-item">
              <CookieIcon style={{ fontSize: 16, marginRight: 8, color: "var(--blue-color)" }} />
              <div>
                <div>
                  <strong>URL:</strong> {cookie.url || "N/A"}
                </div>
                <div>
                  <strong>Name:</strong> {cookie.name || "N/A"}
                </div>
                <div>
                  <strong>User:</strong> {cookie.user || "N/A"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderPasswords = () => {
    if (!client.passwords || client.passwords.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_passwords_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">{t("user.domains_to_monitor_passwords")}</div>
        <div className="accordion-grid-item-content">
          {client.passwords.map((password, index) => (
            <div key={`password-${index}`} className="accordion-list-item">
              <LockIcon style={{ fontSize: 16, marginRight: 8, color: "var(--blue-color)" }} />
              {password}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderPasswordsUrl = () => {
    if (!client.passwordsUrl || client.passwordsUrl.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_passwords_url_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">
          {t("user.domains_to_monitor_passwords_url")}
        </div>
        <div className="accordion-grid-item-content">
          {client.passwordsUrl.map((passwordUrl, index) => (
            <div key={`password-url-${index}`} className="accordion-list-item">
              <DomainIcon style={{ fontSize: 16, marginRight: 8, color: "var(--blue-color)" }} />
              <div>
                <div>
                  <strong>URL:</strong> {passwordUrl.url || "N/A"}
                </div>
                <div>
                  <strong>Domain:</strong> {passwordUrl.domain || "N/A"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderPasswordsApps = () => {
    if (!client.passwordsApps || client.passwordsApps.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_passwords_apps_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">
          {t("user.domains_to_monitor_passwords_apps")}
        </div>
        <div className="accordion-grid-item-content">
          {client.passwordsApps.map((passwordApp, index) => (
            <div key={`password-app-${index}`} className="accordion-list-item">
              <AppsIcon style={{ fontSize: 16, marginRight: 8, color: "var(--blue-color)" }} />
              {passwordApp.domain || ""}
              {passwordApp.wildcard ? "*" : ""}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderUsernames = () => {
    if (!client.usernames || client.usernames.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_usernames_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">{t("user.usernames_to_monitor")}</div>
        <div className="accordion-grid-item-content">
          {client.usernames.map((username, index) => (
            <div key={`username-${index}`} className="accordion-list-item">
              <PersonIcon style={{ fontSize: 16, marginRight: 8, color: "var(--blue-color)" }} />
              {username}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderRansomwares = () => {
    if (!client.ransomwares || client.ransomwares.length === 0) {
      return <div className="accordion-empty-state">{t("user.no_ransomware_monitored")}</div>;
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">{t("user.ransomware_to_monitor")}</div>
        <div className="accordion-grid-item-content">
          {client.ransomwares.map((ransomware, index) => (
            <div key={`ransomware-${index}`} className="accordion-list-item">
              <SecurityIcon style={{ fontSize: 16, marginRight: 8, color: "var(--red-color)" }} />
              <div>
                <div>
                  <strong>Victim:</strong> {ransomware.victim || "No victim"}
                </div>
                <div>
                  <strong>Sector:</strong> {ransomware.sector || "No sector"}
                </div>
                <div>
                  <strong>Gang:</strong> {ransomware.gang || "No gang"}
                </div>
                <div>
                  <strong>Domain:</strong> {ransomware.domain || "No domain"}
                </div>
                <div>
                  <strong>Country:</strong> {ransomware.country || "No country"}
                </div>
                <div>
                  <strong>Company Size:</strong> {ransomware.company_size || "No company size"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderPhishingCanaryWhitelist = () => {
    if (!client.phishingCanaryWhitelist || client.phishingCanaryWhitelist.length === 0) {
      return (
        <div className="accordion-empty-state">{t("user.no_phishing_elements_monitored")}</div>
      );
    }

    return (
      <div className="accordion-grid-item">
        <div className="accordion-grid-item-title">{t("user.phishing_elements_to_monitor")}</div>
        <div className="accordion-grid-item-content">
          {client.phishingCanaryWhitelist.map((phishingElement, index) => (
            <div key={`phishing-element-${index}`} className="accordion-list-item">
              <PhishingIcon
                style={{ fontSize: 16, marginRight: 8, color: "var(--purple-color)" }}
              />
              {phishingElement}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="other-credentials-container">
      <Accordion title={t("user.credit_cards")} icon={<CreditCardIcon />} defaultExpanded={false}>
        {renderCreditCards()}
      </Accordion>

      <Accordion title={t("user.combolists")} icon={<ListIcon />} defaultExpanded={false}>
        {renderCombolists()}
      </Accordion>

      <Accordion title={t("user.cookies")} icon={<CookieIcon />} defaultExpanded={false}>
        {renderCookies()}
      </Accordion>

      <Accordion title={t("user.cookies_client")} icon={<CookieIcon />} defaultExpanded={false}>
        {renderCookiesClient()}
      </Accordion>

      <Accordion
        title={t("user.domains_to_monitor_passwords")}
        icon={<LockIcon />}
        defaultExpanded={false}
      >
        {renderPasswords()}
      </Accordion>

      <Accordion
        title={t("user.domains_to_monitor_passwords_url")}
        icon={<DomainIcon />}
        defaultExpanded={false}
      >
        {renderPasswordsUrl()}
      </Accordion>

      <Accordion
        title={t("user.domains_to_monitor_passwords_apps")}
        icon={<AppsIcon />}
        defaultExpanded={false}
      >
        {renderPasswordsApps()}
      </Accordion>

      <Accordion
        title={t("user.usernames_to_monitor")}
        icon={<PersonIcon />}
        defaultExpanded={false}
      >
        {renderUsernames()}
      </Accordion>

      <Accordion
        title={t("user.ransomware_to_monitor")}
        icon={<SecurityIcon />}
        defaultExpanded={false}
      >
        {renderRansomwares()}
      </Accordion>

      <Accordion
        title={t("user.phishing_elements_to_monitor")}
        icon={<PhishingIcon />}
        defaultExpanded={false}
      >
        {renderPhishingCanaryWhitelist()}
      </Accordion>
    </div>
  );
}

OtherCredentials.propTypes = {
  client: PropTypes.object.isRequired,
};

export default OtherCredentials;
